import awsdk from 'awsdk';

// COVERED
// NOT_COVERED
// REQUEST_VALIDATION_RESPONSE
// FAILED
// CANCELLED

export const EligibilityRequestStatus = awsdk.AWSDKEligibilityRequestStatus;
export type EligibilityRequestStatus = typeof EligibilityRequestStatus;
